/* 7 O'CLOCK – Such-Panel (08.10.2026)
   Liquify tauscht beim Tippen den Bereich li-render="predictive-search-target" aus, lädt bei leerem Feld aber nichts.
   Dieses Script merkt sich den Startzustand (Kategorien, Schnellzugriff, Bestseller) und zeigt ihn wieder,
   sobald das Feld geleert wird. Enter im Feld öffnet wie bisher die Suchergebnisseite. */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('.nav_search-wrapper [li-render="predictive-search-wrapper"]');
    if (!wrap) return;
    var input = wrap.querySelector('[li-render="predictive-search-input"]');
    var target = wrap.querySelector('[li-render="predictive-search-target"]');
    if (!input || !target) return;
    var start = target.innerHTML;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!input.value.trim()) target.innerHTML = start;
      }, 320); /* nach dem Debounce von Liquify (300ms), damit eine späte Antwort nichts überschreibt */
    });
    /* Seite dahinter nicht mitscrollen lassen, solange die Suche offen ist */
    var root = document.documentElement;
    var lockY = 0;
    function lock() {
      if (root.classList.contains('oc-srch-open')) return;
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      root.style.setProperty('--oc-srch-lock-top', (-lockY) + 'px');
      root.classList.add('oc-srch-open');
    }
    function unlock() {
      if (!root.classList.contains('oc-srch-open')) return;
      root.classList.remove('oc-srch-open');
      root.style.removeProperty('--oc-srch-lock-top');
      window.scrollTo(0, lockY);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search="toggle"]')) lock();
      else if (e.target.closest('[fs-modal-element="close-2222"]')) unlock();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') unlock(); });
    /* Formular abgeschickt (Enter / Suchen-Taste) → Sperre lösen, damit die Ergebnisseite normal scrollt */
    var form = input.form;
    if (form) form.addEventListener('submit', function () { root.classList.remove('oc-srch-open'); });
    /* Blinkender Cursor vor „Lieblingsprodukt finden …“, solange das Feld leer und nicht angetippt ist –
       zeigt, dass man hier tippen kann, ohne die Tastatur ungefragt zu öffnen (Alina, 08.10.2026) */
    var holder = input.parentElement;
    var caret = document.createElement('span');
    caret.className = 'oc-srch_caret';
    caret.setAttribute('aria-hidden', 'true');
    holder.appendChild(caret);
    function placeCaret() { caret.style.left = (input.offsetLeft - 3) + 'px'; }
    /* Handy: Fokus ohne Antippen öffnet keine Tastatur und zeigt keinen echten Cursor – dort erst nach dem Antippen ausblenden */
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var tapped = false;
    function syncCaret() {
      var focused = document.activeElement === input && (!touch || tapped);
      holder.classList.toggle('is-active', focused || !!input.value);
      placeCaret();
    }
    input.addEventListener('pointerdown', function () { tapped = true; });
    input.addEventListener('focus', syncCaret);
    input.addEventListener('blur', function () { tapped = false; setTimeout(syncCaret, 0); });
    input.addEventListener('input', syncCaret);
    window.addEventListener('resize', placeCaret);
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search="toggle"]')) setTimeout(syncCaret, 60); });
    syncCaret();
    var wrapEl = document.querySelector('.nav_search-wrapper');
    /* iPhone mit offener Tastatur: Panel bleibt in voller Höhe (keine Lücke). Was von Tastatur bzw. Safari-Leiste
       verdeckt wird, kommt als Innenabstand unten dazu, damit sich alles bis zum letzten Produkt scrollen lässt. */
    function setVh() {
      var vv = window.visualViewport;
      if (!wrapEl || !vv) return;
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      wrapEl.style.setProperty('--oc-srch-kb', kb + 'px');
    }
    setVh();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setVh);
      window.visualViewport.addEventListener('scroll', setVh);
    }
    window.addEventListener('resize', setVh);
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search="toggle"]')) { setVh(); setTimeout(setVh, 400); } });
    /* Treffer verschärft (08.10.2026, Alina): eigener Index aller Produkte (templates/collection.oc-index.liquid),
       gefiltert im Browser. Findet Wortteile und ignoriert Umlaute: „gläser“ → Trinkgläser, Weingläser, Longdrinkgläser …
       Kategorien: alle Navi-Punkte, deren Name das Suchwort enthält, plus Shopifys Kategorie-Vorschläge. */
    var reqId = 0;
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function norm(x) { return (x || '').toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss'); }
    var idxPromise = null;
    function loadIndex() {
      if (idxPromise) return idxPromise;
      function page(n) {
        return fetch(rootUrl + 'collections/all?view=oc-index&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) { var d = document.createElement('div'); d.innerHTML = h; return d.querySelector('.oc-srch_list'); });
      }
      idxPromise = page(1).then(function (ul) {
        if (!ul) return [];
        var total = parseInt(ul.getAttribute('data-oc-total'), 10) || 0;
        var pages = Math.min(6, Math.ceil(total / 250));
        var more = [];
        for (var p = 2; p <= pages; p++) more.push(page(p));
        return Promise.all(more).then(function (rest) {
          var items = [], seen = {};
          [ul].concat(rest).forEach(function (u) {
            if (!u) return;
            Array.prototype.slice.call(u.children).forEach(function (li) {
              var a = li.querySelector('a'); var key = a ? a.getAttribute('href') : '';
              if (seen[key]) return; seen[key] = 1;
              items.push({ el: li, t: norm(li.getAttribute('data-oc-title')) });
            });
          });
          return items;
        });
      }).catch(function () { idxPromise = null; return []; });
      return idxPromise;
    }
    var navCats = [];
    try { var cj = target.querySelector('[data-oc-srch-cats]'); if (cj) navCats = JSON.parse(cj.textContent); } catch (x) {}
    function handleOf(u) { var m = String(u || '').match(/\/collections\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
    var navHandles = {};
    navCats.forEach(function (c) { var h = handleOf(c.u); if (h) navHandles[h] = 1; });
    function wordsOf(term) { return norm(term).split(/\s+/).filter(Boolean); }
    function hitScore(t, words) {
      var s = 0;
      for (var i = 0; i < words.length; i++) {
        var p = t.indexOf(words[i]);
        if (p < 0) return -1;
        /* Zubehör nach hinten: „Untersetzer für Gläser“ ist kein Glas */
        if (t.indexOf('fur ' + words[i]) > -1 && t.replace('fur ' + words[i], '').indexOf(words[i]) < 0) s += 2;
      }
      return s;
    }
    function chipArrow() { return '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4.5 2.5 8 6l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    function esc(x) { var d = document.createElement('div'); d.textContent = x; return d.innerHTML; }
    function blockWith(label, inner) {
      var b = document.createElement('div'); b.className = 'oc-srch_block';
      b.innerHTML = '<div class="oc-srch_label">' + label + '</div>';
      b.appendChild(inner); return b;
    }
    function findBlock(box, label) {
      var ls = box.querySelectorAll('.oc-srch_label');
      for (var i = 0; i < ls.length; i++) if (ls[i].textContent.trim() === label) return ls[i].parentElement;
      return null;
    }
    function applyResults() {
      var term = input.value.trim();
      if (!term) return;
      var my = ++reqId;
      var words = wordsOf(term);
      loadIndex().then(function (items) {
        if (my !== reqId || input.value.trim() !== term) return;
        var box = target.querySelector('.oc-srch.is-results');
        if (!box) return;
        /* Kategorien */
        var have = {}, chips = document.createElement('div'); chips.className = 'oc-srch_chips';
        var haveT = {};
        navCats.forEach(function (c) {
          if (hitScore(norm(c.t), words) < 0 || have[c.u] || haveT[norm(c.t)]) return;
          have[c.u] = 1; haveT[norm(c.t)] = 1;
          var a = document.createElement('a'); a.className = 'oc-srch_chip is-coll'; a.href = c.u; a.innerHTML = esc(c.t) + chipArrow();
          chips.appendChild(a);
        });
        var catBlock = findBlock(box, 'Kategorien');
        /* Shopify-Vorschläge nur übernehmen, wenn die Kollektion in der Navi steht (Alina, 08.10.2026) */
        if (catBlock) Array.prototype.slice.call(catBlock.querySelectorAll('.oc-srch_chip')).forEach(function (a) {
          var u = a.getAttribute('href'), tt = norm(a.textContent.trim());
          if (!navHandles[handleOf(u)]) return;
          if (have[u] || haveT[tt]) return; have[u] = 1; haveT[tt] = 1; chips.appendChild(a);
        });
        if (catBlock && !chips.children.length) { catBlock.remove(); catBlock = null; }
        /* Produkte */
        var hits = [];
        items.forEach(function (it, i) { var sc = hitScore(it.t, words); if (sc >= 0) hits.push({ it: it, sc: sc, i: i }); });
        hits.sort(function (x, y) { return x.sc - y.sc || x.i - y.i; });
        var list = null;
        if (hits.length) {
          list = document.createElement('ul'); list.className = 'oc-srch_list'; list.setAttribute('role', 'list');
          hits.slice(0, 80).forEach(function (h) { list.appendChild(h.it.el.cloneNode(true)); });
        }
        if (!chips.children.length && !list) return;
        /* Leerer Zustand („nichts gefunden“) wird ersetzt */
        var empty = box.querySelector('.oc-srch_empty');
        if (empty) { Array.prototype.slice.call(box.children).forEach(function (n) { n.remove(); }); }
        var foot = box.querySelector('.oc-srch_footer');
        if (!foot) {
          foot = document.createElement('div'); foot.className = 'oc-srch_footer';
          foot.innerHTML = '<a class="oc-srch_all" href="' + rootUrl + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">Alle Ergebnisse für „' + esc(term) + '“</a>';
          box.appendChild(foot);
        }
        var prodBlock = findBlock(box, 'Produkte');
        var pagesBlock = findBlock(box, 'Seiten');
        var anchor = prodBlock || pagesBlock || foot;
        if (chips.children.length) {
          if (catBlock) catBlock.replaceChild(chips, catBlock.querySelector('.oc-srch_chips'));
          else box.insertBefore(blockWith('Kategorien', chips), anchor);
        }
        if (list) {
          if (prodBlock) prodBlock.replaceChild(list, prodBlock.querySelector('.oc-srch_list'));
          else box.insertBefore(blockWith('Produkte', list), pagesBlock || foot);
        }
      });
    }
    document.addEventListener('liquify:predictive-search-rendered', applyResults);
    /* Jedes Öffnen = neue Suche: Feld leeren, Startansicht (Kategorien + Bestseller) zeigen, nach oben (Alina, 08.10.2026) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search="toggle"]')) return;
      reqId++;
      clearTimeout(t);
      loadIndex();
      input.value = '';
      target.innerHTML = start;
      var sc = document.getElementById('predictive-search');
      if (sc) sc.scrollTop = 0;
      syncCaret();
    }, true);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('enterkeyhint', 'search');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
